import { render, staticRenderFns } from "./MspMisurazioneItem.vue?vue&type=template&id=f58457aa"
import script from "./MspMisurazioneItem.vue?vue&type=script&lang=js"
export * from "./MspMisurazioneItem.vue?vue&type=script&lang=js"
import style0 from "./MspMisurazioneItem.vue?vue&type=style&index=0&id=f58457aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports